<template>
    <div :class="['bk-header', { 'is-static': isStatic || isFixed }]">
        <img
                class="bk-logo"
                src="../images/common/logo.png"
                width="188px"
                height="32px"
                alt="蓝鲸智云|S-mart"
                @click="goToDoc(navList[0])"/>
        <ul class="bk-nav">
            <li
                    :class="['nav-menu', { 'active': curNavTab === nav.name}]"
                    v-for="(nav, navIndex) in navList"
                    :key="navIndex">
                <template v-if="nav.children">
                    <el-popover placement="bottom" trigger="hover" :popper-class="'second-nav-pop'">
                        <div slot="reference" @click="goToDoc(nav)">
                            <span :class="['nav-title', { 'default': !nav.url }]">{{ nav.title }}</span>
                        </div>
                        <div class="child-list">
                            <div v-for="(child, childIdx) in nav.children" :key="childIdx" class="child-item">
                                <p class="second-title">
                                    <span :class="[{ 'is-link': child.url }]" @click="goToDoc(child)">{{
                                            child.title
                                        }}</span>
                                </p>
                                <ul class="second-list">
                                    <li
                                            v-for="item in child.list"
                                            :key="item.url"
                                            :class="{ 'active': secondNav === item.name, 'is-disable': item.disable }"
                                            @click="goToDoc(item)">
                                        <span>{{ item.title }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </el-popover>
                    <img class="triangle" src="../images/community/angle-down.png" alt="">
                </template>
                <template v-else>
                    <span class="nav-title" @click="goToDoc(nav)">{{ nav.title }}</span>
                </template>
            </li>
        </ul>
        <!-- <div class="bk-search">
            <el-input class="input" suffix-icon="el-icon-search" placeholder="请输入关键字" v-model="searchVal"></el-input>
        </div> -->
        <div class="online-experience">
            <div class="experience" @click="goToDoc({ url: '/s-mart/online-env' })">在线体验</div>
        </div>
        <template v-if="!isLogin">
            <a @click="login()" href="javascript:;" class="login-btn">登录</a>
        </template>
        <template v-else>
            <el-popover
                    placement="bottom"
                    trigger="click"
                    popper-class="msg-popover"
                    v-model="visible">
                <span class="msg-icon" slot="reference">
                    <i :class="['message-solid', {'active': visible}]"></i>
                    <i class="red-circle" v-if="isHaveUnread"></i>
                </span>
                <div class="popover-content" v-loading="loading">
                    <p class="msg-title">
                        <span class="title">
                            消息通知
                            <span class="num">({{ msgLength }})</span>
                        </span>
                        <span class="view-more" @click="onViewMore">查看更多</span>
                    </p>
                    <el-tabs class="msg-content" v-model="activeMsg" @tab-click="handleTabClick">
                        <el-tab-pane
                                class="tab-item"
                                v-for="tabItem in msgTabList"
                                :key="tabItem.name"
                                :name="tabItem.name">
                        <span slot="label">
                        <el-badge :hidden="!tabsTotal[tabItem.name]" :value="tabsTotal[tabItem.name]" :max="99">
                            {{ tabItem.label }}
                        </el-badge>
                        </span>
                        </el-tab-pane>
                    </el-tabs>
                    <ul class="val-list" v-loading="loading ? false : tabLoading" element-loading-text="拼命加载中">
                        <template v-if="componentData.length">
                            <li
                                    class="val-item"
                                    v-for="(infoItem, infoIndex) in componentData"
                                    :key="infoIndex">
                                <span class="val-circle"></span>
                                <p class="val-content" v-html="filterXSS(infoItem.notify)"></p>
                                <span class="val-time">{{ infoItem.updated }}</span>
                            </li>
                        </template>
                        <li v-else class="data-null">
                            <img src="../images/personal_center/data-null.png" alt="">
                            <p>没有数据</p>
                        </li>
                    </ul>
                </div>
            </el-popover>
            <el-popover placement="bottom" trigger="hover" width="227" :popper-class="'user-info-pop'">
                <div slot="reference" class="user-info">
                    <span class="name">{{ userInfo.nick_name }}</span>
                    <el-tooltip v-if="userInfo.is_official" effect="light" content="蓝鲸智云官方" placement="right">
                        <svg style="width: 20px; height: 20px" aria-hidden="true">
                            <use xlink:href="#icon-lanjingguanfang"></use>
                        </svg>
                    </el-tooltip>
                    <el-tooltip v-if="userInfo.is_vip" effect="light" content="核心用户" placement="right">
                        <span class="icon-vipuser"></span>
                    </el-tooltip>
                </div>
                <p class="whale" @click="skip('/s-mart/personal_center/')">
                    <img src="../images/community/coins.png"
                         v-if="!userInfo.avatar || userInfo.avatar.substr(0, 1) === '?'">
                    <img v-else :src="userInfo.avatar" alt=""/>
                    <span class="text">鲸币</span>
                    <span class="count">{{ userInfo.bkb | formatNumber }}</span>
                </p>
                <p class="menu-item" @click="skip('/s-mart/personal_center/')">个人中心</p>
                <p class="menu-item" @click="skip('/s-mart/personal_center/store')">鲸币商城</p>
                <p class="menu-item" @click="skip('/s-mart/vip')">{{ userInfo.is_vip ? '查看我的核心权益' : '申请成为核心用户' }}</p>
                <a class="menu-item" href="javascript:smart.logout(logout_callback);">退出登录</a>
            </el-popover>
            <img class="triangle" src="../images/community/angle-down.png" alt="">
        </template>

        <secondary :show="secondaryState" :hasEmail="emailState" :hasPhone="phoneState"></secondary>
    </div>
</template>

<script>
import secondary from "./secondary.vue"
import Cookies from 'js-cookie'

export default {
    filters: {
        formatNumber(num) {
            num += ''
            let x = num.split('.')
            let x1 = x[0]
            let x2 = x.length > 1 ? '.' + x[1] : ''
            let rgx = /(\d+)(\d{3})/
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2')
            }
            return x1 + x2
        }
    },
    components: {
        secondary
    },
    props: {
        account: {
            type: Object,
            default: () => ({})
        },
        user: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            navList: [
                {
                    title: '项目简介',
                    url: '/index/',
                    name: 'index'
                }, {
                    title: '文档中心',
                    url: 'https://bk.tencent.com/docs/',
                    name: 'docs',
                    isCloud: true,
                    children: [
                        {
                            title: '文档中心',
                            url: 'https://bk.tencent.com/docs/',
                            name: 'docs',
                            isCloud: true,
                            list: [
                                {
                                    title: '快速入门',
                                    url: '/docs/markdown/7.0/快速入门/quick-start-v7.0-info.md',
                                },
                                {
                                    title: '部署维护',
                                    url: '/docs/markdown/ZH/DeploymentGuides/7.2/index.md',
                                },
                                {
                                    title: '场景案例',
                                    url: '/docs/markdown/7.0/开发指南/开发简介/README.md',
                                },
                                {
                                    title: '开发指南',
                                    url: '/docs/markdown/7.0/bk_solutions/CD/CMDB/CMDB_management_hosts.md',
                                },
                                {
                                    title: '视频教程',
                                    url: '/s-mart/video/'
                                },
                                {
                                    title: '常见问题',
                                    url: 'https://bk.tencent.com/docs/document/6.0/151/6881',
                                    isCloud: true
                                }
                            ]
                        }
                    ]
                }, {
                    title: '学习社区',
                    url: '/s-mart/communities/',
                    name: 'community',
                    target: true,
                    children: [
                        {
                            title: '蓝鲸社区',
                            url: '/s-mart/communities/',
                            name: 'community',
                            target: true,
                            list: [
                                {
                                    title: '社区问答',
                                    url: '/s-mart/community/question',
                                    name: 'community-question',
                                    target: true
                                }, {
                                    title: '技术文章',
                                    url: '/s-mart/community/article',
                                    name: 'community-article',
                                    target: true
                                }, {
                                    title: '社区活动',
                                    url: '',
                                    name: '',
                                    disable: true
                                }, {
                                    title: '核心用户',
                                    url: '/s-mart/vip/',
                                    name: 'community-vip',
                                    target: true
                                }
                            ]
                        }, {
                            title: 'Education',
                            list: [
                                {
                                    title: '培训认证',
                                    url: '/training_exam/'
                                }, {
                                    title: '蓝鲸校园',
                                    url: '/school_edition/'
                                }
                            ]
                        }
                    ]
                }, {
                    title: '下载',
                    url: '/s-mart/downloads',
                    name: 'downloads',
                    target: true,
                }, {
                    title: 'S-mart 市场',
                    url: '/s-mart/market',
                    name: 'market',
                    router: true
                }, {
                    title: '合作伙伴',
                    url: '/cooperation_partner/',
                    name: 'partner'
                }, {
                    title: '关于蓝鲸',
                    name: 'about',
                    children: [
                        {
                            title: '关于蓝鲸',
                            url: '/info/#about',
                            list: [
                                {
                                    title: 'MagicBox',
                                    url: 'https://magicbox.bk.tencent.com/static_api/v3/main/index.html',
                                    isCloud: true,
                                    target: true
                                }, {
                                    title: '蓝鲸动态',
                                    url: '/info/#news'
                                }, {
                                    title: '招聘信息',
                                    url: '/info/#recruit'
                                }, {
                                    title: '法律申明',
                                    url: '/info/#laws'
                                }, {
                                    title: '关于我们',
                                    url: '/info/#about'
                                }
                            ]
                        }
                    ]
                }
            ],
            curNavTab: '',
            secondNav: '',
            searchVal: '',
            versionList: [
                {
                    title: '线上体验环境',
                    url: 'https://ce.bktencent.com/',
                    isCloud: true,
                    target: true
                }, {
                    title: '开发学习',
                    url: 'https://paas-edu.bktencent.com',
                    isCloud: true,
                    target: true
                }
            ],
            isLogin: false,
            userInfo: {},
            isStatic: false,
            isFixed: false,
            tabsTotal: {
                follow: 0,
                remind: 0,
                latter: 0,
                system: 0
            },
            tabsData: {
                follow: [],
                remind: [],
                latter: [],
                system: []
            },
            msgTabList: [
                {
                    label: '回复与获赞',
                    name: 'follow'
                }, {
                    label: '关注更新',
                    name: 'remind'
                }, {
                    label: '系统消息',
                    name: 'system'
                }
            ],
            loading: false,
            followLoading: false,
            remindLoading: false,
            latterLoading: false,
            systemLoading: false,
            isHaveUnread: false,
            componentData: [],
            activeMsg: 'follow',
            prevActive: '',
            visible: false
        }
    },
    computed: {
        tabLoading() {
            return this[`${this.activeMsg}Loading`]
        },
        msgLength() {
            let result = 0
            Object.values(this.tabsTotal).forEach(item => {
                result += item
            })
            if (!result) {
                this.isHaveUnread = false
            }
            return result
        },
        secondaryState() {
            return this.$store.state.secondaryShow
        },
        emailState() {
            return this.$store.state.hasEmail
        },
        phoneState() {
            return this.$store.state.hasPhone
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.componentData = []
                this.getAllTabMsgList()
            }
        },
        "account.bkb": function (val) {
            this.userInfo.bkb = val
        },
        '$route'(val) {
            this.initCurNavTab()
        }
    },
    mounted() {
        this.init()
        this.initCurNavTab()
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        handleScroll() {
            this.isStatic = window.scrollY > 0
        },
        goToDoc(navInfo) {
            if (!navInfo.url) return
            if (navInfo.router) {
                this.$router.push({path: navInfo.url})
            } else {
                const {url, isCloud, target} = navInfo
                const link = isCloud ? url : (window.location.origin + url)
                window.open(link, (target || isCloud) ? '_blank' : '_self')
            }
        },
        initCurNavTab() {
            const {name} = this.$route
            let curNavTab, secondNav = ''
            if (name) {
                if (name.search('-') > -1) {
                    curNavTab = name.split('-')[0]
                    secondNav = name
                } else {
                    curNavTab = name
                    secondNav = ''
                }
            } else {
                const path = window.location.pathname
                this.navList.forEach(navItem => {
                    if (path.indexOf(navItem.url) > -1) {
                        curNavTab = navItem.name
                    } else {
                        let isMatch = false
                        const marketList = ['market', 'application/']
                        marketList.forEach(item => {
                            if (path.indexOf(item) > -1) {
                                isMatch = true
                            }
                        })
                        if (isMatch || ['/s-mart', '/s-mart/'].includes(path)) {
                            curNavTab = 'market'
                        } else if (path.indexOf('/s-mart') > -1) {
                            curNavTab = 'community'
                        }
                    }
                    if (navItem.children) {
                        navItem.children.some(item => {
                            if (item.url === path) {
                                secondNav = item.name
                                return true
                            }
                        })
                    }
                })
            }
            this.curNavTab = curNavTab
            this.secondNav = secondNav
            // 固定导航
            const path = window.location.pathname
            let isFixed = true
            if (['/s-mart', '/s-mart/'].includes(path)) {
                isFixed = false
            } else {
                ['vip', 'personal_center'].forEach(item => {
                    if (path.indexOf(item) > -1) {
                        isFixed = false
                    }
                })
            }
            this.isFixed = isFixed
        },
        login() {
            try {
                axios.post(myUrl + "login/get_user_info/").then((res) => {
                    res = res.data
                    this.userInfo = res.data
                    this.isLogin = true
                    localStorage.setItem('isFirstLogin', true)
                    this.$store.commit('setLoginStatus', true)
                    this.$store.commit('setUserInfo', res.data)
                })
            } catch (error) {
                console.warn(error)
            }
        },
        // 查看更多
        onViewMore() {
            let routeData = this.$router.resolve({
                path: `/s-mart/personal_center/message_center/?tabName=${this.activeMsg}`
            });
            window.open(routeData.href, '_blank')
            this.visible = false
        },
        // 查询是否有未读数据
        getHaveUnread() {
            try {
                axios.get(myUrl + `api/notify/record/have_unread/`).then(res => {
                    if (!res.data.result) return
                    this.isHaveUnread = res.data.data.have_unread
                })
            } catch (error) {
                console.warn(error)
            }
        },
        pollingHaveUnread() {
            Promise.resolve(this.getHaveUnread()).then(res => {
                setTimeout(() => {
                    this.pollingHaveUnread()
                }, 300000);
            })
        },
        // 获取所有tab的消息列表
        async getAllTabMsgList() {
            this.loading = true
            const promiseArray = this.msgTabList.map(item => this.getTabContent(item.name))
            Promise.all(promiseArray).then(res => {
                this.loading = false
                // activeMsg 默认为tab栏第一个有未读消息的
                for (const [key, value] of Object.entries(this.tabsTotal)) {
                    if (value !== 0) {
                        this.activeMsg = key
                        this.componentData = this.tabsData[key].map(item => {
                            item.updated = this.getTime(item.create_time)
                            return item
                        })
                        this.onReadNotify(key)
                        return
                    }
                }
            })
        },
        // 获取tab栏内容数据
        async getTabContent(type = this.activeMsg) {
            try {
                this[`${type}Loading`] = true
                await axios.get(myUrl + `api/notify/record/list_unread/?type=${type}`).then(res => {
                    if (!res.data.result) return
                    const {total, data} = res.data.data
                    this.tabsTotal[type] = total
                    this.tabsData[type] = data
                    if (type === this.activeMsg) {
                        this.componentData = data
                        this.componentData.forEach(item => {
                            item.updated = this.getTime(item.create_time)
                        })
                    }
                    this[`${type}Loading`] = false
                })
            } catch (error) {
                console.warn(error)
                this[`${type}Loading`] = false
            }
        },
        // 切换tab
        handleTabClick(data) {
            this.getTabContent()
            this.onReadNotify(data.name)
        },
        // 单个tab已读
        onReadNotify(type) {
            if (!this.prevActive) {
                this.prevActive = type
                return
            }
            axios.put(myUrl + `api/notify/record/read/?type=${this.prevActive}`).then(res => {
                if (!res.data.result) return
                this.tabsTotal[this.prevActive] = 0
                this.prevActive = type
            })
        },
        getTime(stringTime) {
            let minute = 1000 * 60;
            let hour = minute * 60;
            let day = hour * 24;
            let week = day * 7;
            let month = day * 30;
            let time1 = new Date().getTime(); // 当前的时间戳
            let time2 = Date.parse(new Date(stringTime)); // 指定时间的时间戳
            let time = time1 - time2;
            let result = null;
            const date = stringTime.split(' ')[0]
            if (time / month >= 1 || time / week >= 1) {
                result = date
            } else if (time / day >= 1) {
                result = parseInt(time / day) + '天前';
            } else if (time / hour >= 1) {
                result = parseInt(time / hour) + '小时前';
            } else if (time / minute >= 1) {
                result = parseInt(time / minute) + '分钟前';
            } else {
                result = '刚刚'
            }
            return result;
        },
        // 跳转
        skip(link) {
            try {
                axios.post(myUrl + "login/check/register/").then((res) => {
                    res = res.data
                    if (res.result) {
                        this.$router.push({
                            path: link
                        })
                        this.curNavTab = 'community'
                    }
                })
            } catch (error) {
                console.warn(error)
            }
        },
        init() {
            let isFirstLogin = localStorage.getItem('isFirstLogin')
            if (isFirstLogin === null) {
                localStorage.setItem('isFirstLogin', true)
            }
            if (!Cookies.get('p_skey')) return
            try {
                
                axios.post(myUrl + "login/check/").then((res) => {
                    if (!res.data.status) {
                        return
                    }
                    // 获取用户登录信息
                    this.getUserInfo()
                })
                this.username = window.username
            } catch (error) {
                console.warn(error)
            }
        },
        getUserInfo() {
            try {
                axios.post(myUrl + "login/get_user_info/").then((res) => {
                    const resp = res.data
                    // 用户已登录
                    this.isLogin = true
                    this.userInfo = resp.data
                    this.user.uid = resp.data.user_id
                    if (resp.data.user_id) {
                        this.$store.commit('setUserInfo', resp.data)
                        this.$store.commit('setLoginStatus', true)
                        // 如果用户登录则轮询查是否有未读数据
                        this.pollingHaveUnread()
                    }
                    const isFirstLogin = localStorage.getItem('isFirstLogin')
                    if (isFirstLogin === 'true') {
                        localStorage.setItem('isFirstLogin', false)
                        const {information_popup, wx_popup} = resp.data
                        if (information_popup) { // 弹出信息完善弹框
                            this.$parent.isInformationPopup = true
                        } else if (wx_popup) { // 弹出关注社区二维码
                            this.$parent.isWxPopup = true
                        }
                    }
                })
            } catch (error) {
                console.warn(error)
            }
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/scrollbar.scss';

.msg-popover {
    z-index: 1000001 !important;
    width: 360px;
    height: 396px;
    padding: 0;

    .popover-content {
        padding: 14px 0 !important;

        .el-loading-mask {
            top: 1px;
        }
    }

    .msg-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding: 0 16px 0;
        margin-bottom: 8px;

        .title {
            font-weight: 700;
            color: #63656e;
            line-height: 19px;

            .num {
                color: #63656e;
                width: 36px;
                font-weight: 400;
                text-align: center;
            }
        }

        .view-more {
            cursor: pointer;
            color: #3a84ff;
            font-size: 12px;
        }
    }

    .msg-content {
        font-size: 12px;

        .el-tabs__header {
            padding: 0 16px;
            margin-bottom: 0;

            .el-tabs__nav-wrap::after {
                height: 1px;
                background: #dcdee5;
            }

            .el-tabs__nav {
                height: 36px;
                width: 100%;

                .el-tabs__active-bar {
                    width: 60px !important;
                    height: 2px !important;
                    background: #3a84ff;
                }

                .el-tabs__item {
                    padding: 0 18px;
                    height: 36px;
                    width: 60px;
                    text-align: center;
                    box-sizing: content-box;
                    line-height: 36px;
                    text-align: center;
                    font-size: 12px !important;
                    color: #63656e;

                    .el-badge__content {
                        top: 8px !important;
                        right: 10px;
                        color: #ffffff;
                        padding: 0 5px;
                        background: #ea3636;
                        font-family: HelveticaNeue;
                    }

                    &.is-active,
                    &:hover {
                        color: #3a84ff;
                    }

                    &:nth-child(2) {
                        padding-left: 0 !important;
                    }
                }
            }
        }
    }

    .val-list {
        color: #63656e;
        line-height: 20px;
        height: 300px;
        overflow-y: auto;
        @include scrollbar;
        padding: 7px 16px 20px;
        font-size: 12px;

        .val-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;

            .val-circle {
                align-self: start;
                display: inline-block;
                flex-shrink: 0;
                width: 4px;
                height: 4px;
                background: #979ba5;
                border-radius: 50%;
                margin: 8px 12px 0 0;
            }

            .val-content {
                flex: 1;
                text-align: left;
                color: #63656e;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                /* autoprefixer: off */
                -webkit-box-orient: vertical;
                /* autoprefixer: on */
                em {
                    font-style: normal;
                }

                a:hover {
                    text-decoration: underline;
                }
            }

            .val-time {
                color: #c4c6cc;
                flex-shrink: 0;
                align-self: start;
                min-width: 60px;
                text-align: right;
                margin-left: 10px;
            }

            &:hover {
                .val-circle {
                    background: #3a84ff;
                }
            }
        }
    }

    .data-null {
        padding: 80px 0 20px;
        width: 100%;
        text-align: center;
        color: #63656e;

        img {
            width: 150px;
            height: 80px;
            margin-bottom: 10px;
        }
    }
}

.bk-search {
    width: 172px;
    height: 60px;

    .el-input__inner {
        height: 60px;
        border: none;
        background: rgba($color: #fff, $alpha: 0.08);
        font-size: 14px;
        color: #fff;

        &::placeholder {
            color: #fafbfd;
        }
    }

    .el-input__suffix {
        top: 3px;
        font-size: 17px;
        color: #fff;
    }

    transition: width .3s;

    &:focus-within {
        width: 369px;
    }
}

.second-nav-pop {
    z-index: 100005 !important;
    padding: 20px 20px 8px;
    box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.12);

    .child-list {
        display: flex;

        .child-item:nth-child(2) {
            margin-left: 32px;
        }
    }

    .second-title {
        width: 170px;
        font-size: 14px;
        font-weight: 500;
        text-align: left;
        color: #313238;
        line-height: 32px;
        padding-bottom: 5px;
        margin-bottom: 8px;
        border-bottom: 1px solid #dcdee5;

        .is-link {
            cursor: pointer;

            &:hover {
                color: #3a84ff;
            }
        }
    }

    .second-list li {
        font-size: 12px;
        text-align: left;
        color: #63656e;
        line-height: 32px;

        &:hover {
            cursor: pointer;
            color: #5082fa;
        }

        &.active {
            color: #5082fa;
        }

        &.is-disable {
            color: #c4c6cc;
            cursor: not-allowed;
        }
    }
}

.experience-pop {
    padding: 7px 0;
    z-index: 100005 !important;
    min-width: 100px !important;

    .tippy-tooltip {
        box-shadow: none !important;
    }

    .more-item {
        line-height: 32px;
        text-align: left;
        margin: 0 20px;
        font-size: 12px;
        color: #63656e;
        cursor: pointer;

        &:hover {
            color: #3a84ff;
        }
    }
}

.user-info-pop {
    padding: 0 0 6px;
    z-index: 100005 !important;

    .whale {
        display: flex;
        align-items: center;
        padding: 15px 0 9px;
        margin: 0 12px;
        color: #979ba5;
        margin-bottom: 6px;
        cursor: pointer;
        border-bottom: 1px solid #dcdee5;

        img {
            height: 32px;
            width: 32px;
            margin-right: 5px;
        }

        .text {
            flex: 1;
            font-size: 12px;
        }

        .count {
            font-size: 16px;
            color: #313238;
            font-weight: 600;
            margin-right: 10px;
        }
    }

    .menu-item {
        display: block;
        color: #63656e;
        height: 32px;
        line-height: 32px;
        padding-left: 20px;
        font-size: 12px;
        cursor: pointer;

        &:hover {
            background: #e1ecff;
            color: #5082fa;
        }
    }
}

.bk-header:hover {
    .bk-search .el-input__inner {
        background: rgba($color: #fff, $alpha: 0.08);
    }
}
</style>
<style lang="scss" scoped>
.bk-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10003;
    width: 100%;
    min-width: 1200px;
    height: 60px;
    display: flex;
    align-items: center;
    font-family: PingFang SC, Microsoft YaHei, Helvetica, sans-serif;
    padding: 0 30px 0 24px;
    background: rgba($color: #0a0a1a, $alpha: 0.1);

    .bk-logo {
        margin-right: 80px;
        cursor: pointer;
    }

    .bk-nav {
        flex: 1;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        height: 100%;

        .nav-menu {
            height: 100%;
            display: flex;
            align-items: center;
            flex-shrink: 0;
            color: #ffffff;
            opacity: 0.76;
            margin-right: 30px;

            .nav-title {
                position: relative;
                display: inline-block;
                line-height: 56px;
                cursor: pointer;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: -2px;
                    left: 0;
                    right: 0;
                    margin: 0 auto;
                    width: 20px;
                    height: 2px;
                    background: #ffffff;
                    border-radius: 1px;
                    opacity: 0;
                }
            }

            .default {
                cursor: default;
            }

            &:hover, &.active {
                opacity: 1;

                .nav-title::after {
                    content: '';
                    opacity: 1;
                }
            }
        }
    }

    .triangle {
        position: relative;
        left: -0;
        height: 18px;
    }

    .online-experience {
        margin-left: 35px;
        color: #fff;
        cursor: pointer;
        opacity: 0.76;
        line-height: 56px;

        &:hover {
            opacity: 1;
        }
    }

    .login-btn {
        display: inline-block;
        width: 80px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        color: #fff;
        border-radius: 18px;
        border: 1px solid rgba(255, 255, 255, .15);
        margin-left: 30px;

        &:hover {
            color: #fff;
            background: #3a84ff;
            border-color: #3a84ff;
        }
    }

    .msg-icon {
        margin-left: 32px;
        position: relative;

        .message-solid {
            height: 16px;
            width: 16px;
            display: inline-block;
            cursor: pointer;
            position: relative;
            top: 2px;
            right: 0px;
            background-image: url('../images/community/notice-fill.png');
            background-size: 100% 100%;

            &.active,
            &:hover {
                background-image: url('../images/community/lamp-nine-hover.png');
                background-size: 100% 100%;
            }
        }

        .red-circle {
            position: absolute;
            top: 1px;
            right: -1px;
            width: 8px;
            height: 8px;
            background: #ea3536;
            border: 1px solid #0a0a1a;
            border-radius: 50%;
        }
    }

    .user-info {
        display: flex;
        align-items: center;
        margin-left: 30px;
        color: #fff;
        cursor: pointer;
        opacity: 0.76;

        .name {
            margin-right: 2px;
        }

        &:hover {
            opacity: 1;
        }
    }

    &:hover, &.is-static {
        background: rgba($color: #0a0a1a, $alpha: 0.86);
    }
}
</style>
>>>>>>> b1c6a41 ([deploy]: 添加官方账号标识)



// WEBPACK FOOTER //
// header.vue?3727ded2